import { ListBulletIcon } from '@heroicons/react/24/outline'

interface Page {
  name: string
  href: string
  current: boolean
  isHome?: boolean
}

export default function Breadcrumb({ pages }: { pages: Page[] }) {
  return (
    <nav aria-label="Breadcrumb" className="flex">
      <ol role="list" className="flex space-x-4 rounded-md bg-white px-6 shadow">
        {pages.map((page) => (
          page.isHome ? (
            <li key={page.name} className="flex">
              <div className="flex items-center">
                <a href={page.href} className="text-gray-400 hover:text-gray-500">
                  <ListBulletIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0" />
                  <span className="sr-only">{page.name}</span>
                </a>
              </div>
            </li>
          ) : (
            <li key={page.name} className="flex">
              <div className="flex items-center">
                <svg
                  fill="currentColor"
                  viewBox="0 0 24 44"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                  className="h-full w-6 flex-shrink-0 text-gray-200"
                >
                  <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                </svg>
                <a
                  href={page.href}
                  aria-current={page.current ? 'page' : undefined}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  {page.name}
                </a>
              </div>
            </li>
          )
        ))}
      </ol>
    </nav>
  );
}
